import * as React from 'react';
import { ReactNode } from 'react';
import { connect } from 'react-redux';
import * as MediaQuery from 'react-responsive';

import { IApplicationState, TDeviceType } from '../../types/redux';

interface IReactChildren {
  deviceType: TDeviceType;
  children: ReactNode;
}

const initialDeviceWidth = (deviceType: TDeviceType): number => {
  switch (deviceType) {
    case 'phone':
      return 320;
    case 'tablet':
      return 768;
    case 'desktop':
    default:
      return 1025;
  }
};

const MobileQuery = ({ deviceType, children }: IReactChildren) =>
  <MediaQuery
    maxWidth={767}
    children={children}
    values={{ width: initialDeviceWidth(deviceType) }}
  />;

const TabletQuery = ({ deviceType, children }: IReactChildren) =>
  <MediaQuery
    minWidth={768}
    maxWidth={1024}
    children={children}
    values={{ width: initialDeviceWidth(deviceType) }}
  />;

const DesktopQuery = ({ deviceType, children }: IReactChildren) =>
  <MediaQuery
    minWidth={1025}
    children={children}
    values={{ width: initialDeviceWidth(deviceType) }}
  />;

const NotDesktopQuery = ({ deviceType, children }: IReactChildren) =>
  <MediaQuery
    maxWidth={1024}
    children={children}
    values={{ width: initialDeviceWidth(deviceType) }}
  />;

export const Mobile = connect(
  (state: IApplicationState) => ({
    deviceType: state.helper.deviceType,
  }),
)(MobileQuery);

export const Tablet = connect(
  (state: IApplicationState) => ({
    deviceType: state.helper.deviceType,
  }),
)(TabletQuery);

export const Desktop = connect(
  (state: IApplicationState) => ({
    deviceType: state.helper.deviceType,
  }),
)(DesktopQuery);

export const NotDesktop = connect(
  (state: IApplicationState) => ({
    deviceType: state.helper.deviceType,
  }),
)(NotDesktopQuery);
